import { css } from 'styled-components'
import Theme from '@styles/Theme'

export const sizes = {
  xs: Theme.breakpoints[0],
  sm: Theme.breakpoints[1],
  md: Theme.breakpoints[2],
  lg: Theme.breakpoints[3],
  xl: Theme.breakpoints[4],
  xxl: Theme.breakpoints[5],
}

// Iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export const mediaUp = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label]}) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export default media
